module.exports = __webpack_public_path__ + "img/6.5833f489.jpg";